import { StepKey } from "@/src/lib/workflows/steps/types";

const caseStepKeys = [
  StepKey.ENSURE_PATIENT,
  StepKey.CLINICIENT_ENSURE_CASE,
  StepKey.CLINICIENT_CONFIGURE_CASE,
  StepKey.CLINICIENT_CASE_DOCUMENT_UPLOAD,
  StepKey.CLINICIENT_DOCUMENT_NOTE,
  StepKey.CLINICIENT_SYNC_INSURANCE,
] as const;
const legacyStepKeys = [...caseStepKeys, StepKey.REFERRAL_SHEET_EXPORT] as const;

/** The referral sync sequence shared by workflow execution and the Steps view. Export stays last. */
const referralStepKeysBeforeFax = [
  ...caseStepKeys,
  StepKey.CLINICIENT_ENSURE_AUTHORIZATION,
  StepKey.CLINICIENT_AUTHORIZATION_DOCUMENT_UPLOAD,
  StepKey.CLINICIENT_AUTHORIZATION_TASK,
  StepKey.REFERRAL_SHEET_EXPORT,
] as const;

export const CONFLUENT_REFERRAL_STEP_KEYS = [StepKey.REQUIRE_PATIENT_PHONE, ...referralStepKeysBeforeFax] as const;

export type ConfluentReferralStepKey = (typeof CONFLUENT_REFERRAL_STEP_KEYS)[number];

export function getConfluentReferralStepKeys(
  persistedStepKeys: readonly string[] = []
): readonly ConfluentReferralStepKey[] {
  // An export already recorded at the old index must remain the last step. Its retry handler
  // requires that index, and inserting authorization writes would replace the existing row.
  // Preserve pre-fax indices for in-flight referrals. Resuming the old first-step information hold
  // deletes that row, so a task with no remaining steps picks up the new fax check on its next run.
  // TODO: Remove this compatibility branch and the legacy sequences once all tasks using them
  // have finished or been migrated to the new flow with their persisted step indices updated.
  if (persistedStepKeys[0] === StepKey.ENSURE_PATIENT) {
    return persistedStepKeys[caseStepKeys.length] === StepKey.REFERRAL_SHEET_EXPORT
      ? legacyStepKeys
      : referralStepKeysBeforeFax;
  }

  return CONFLUENT_REFERRAL_STEP_KEYS;
}
